import { Stack, Typography } from "@braintrust/braintrust-ui-components";
import { fetchCurrentUser } from "@js/apps/auth/actions";
import { useFreelancerId } from "@js/apps/common/hooks/use-freelancer-id";
import { useUpdateTaxFormMutation } from "@js/apps/freelancer/api";
import { Snackbar } from "@js/components/snackbar";
import { useAppDispatch } from "@js/hooks";

import { TaxDocumentOverrideButton } from "../tax-document-override-button";

import type { AddW8FormData } from "./add-w8-form";
import { AddW8Form } from "./add-w8-form";

type AddW8ModalContentProps = {
  closeModal: () => void;
  showSwitchFormButton?: boolean;
};

export const AddW8ModalContent = ({
  closeModal,
  showSwitchFormButton,
}: AddW8ModalContentProps) => {
  const dispatch = useAppDispatch();
  const freelancerId = useFreelancerId();
  const [updateTaxForm] = useUpdateTaxFormMutation();

  const onSubmit = (values: AddW8FormData) => {
    if (!freelancerId) {
      return;
    }

    return updateTaxForm({
      freelancerId,
      formType: "w8",
      formFileId: values.w8_form,
    }).then(() => {
      dispatch(fetchCurrentUser()).catch(() => null);

      closeModal();
      Snackbar.success(`Saved Successfully.`);
    });
  };

  return (
    <>
      <Stack
        direction="row"
        sx={{
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          mb: "30px",
          gap: 1,
        }}
      >
        <Typography
          component="h3"
          variant="title"
          fontWeight={400}
          size="small"
        >
          W-8 Form
        </Typography>
        {showSwitchFormButton && (
          <TaxDocumentOverrideButton formType={ENUMS.TaxForm.W8_FORM} />
        )}
      </Stack>

      <Typography component="p" sx={{ mb: 1 }}>
        Upload a completed W-8. In case of an error, the newest form uploaded
        will be used by Braintrust.
      </Typography>
      <AddW8Form onSubmit={onSubmit} onClose={closeModal} />
    </>
  );
};
